/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { currencySymbolEnumSchema } from "./currencySymbolEnumSchema.ts";
import { defaultLanguageEnumSchema } from "./defaultLanguageEnumSchema.ts";
import { loyaltyEnumSchema } from "./loyaltyEnumSchema.ts";
import { supportedLanguagesEnumSchema } from "./supportedLanguagesEnumSchema.ts";

export const organizationGuestSchema = z.object({
	id: z.uuid(),
	name: z.string().max(255),
	org_units: z.array(z.any()),
	currency_symbol: currencySymbolEnumSchema.describe("* `₽` - RUB\n* `$` - USD\n* `₸` - KZT\n* `€` - EUR\n* `₾` - GEL\n* `֏` - AMD\n* `AED` - AED"),
	default_language: defaultLanguageEnumSchema
		.optional()
		.describe(
			"* `ru` - Русский\n* `en` - Английский\n* `es` - Испанский\n* `ar` - Арабский\n* `zh` - Китайский\n* `kk` - Казахский\n* `hy` - Армянский\n* `ka` - Грузинский\n* `az` - Азербайджанский\n* `uz` - Узбекский",
		),
	supported_languages: supportedLanguagesEnumSchema
		.optional()
		.describe(
			"* `ru` - Русский\n* `en` - Английский\n* `es` - Испанский\n* `ar` - Арабский\n* `zh` - Китайский\n* `kk` - Казахский\n* `hy` - Армянский\n* `ka` - Грузинский\n* `az` - Азербайджанский\n* `uz` - Узбекский",
		),
	has_loyalty_default_user: z.boolean(),
	has_loyalty: z.boolean(),
	loyalty: loyaltyEnumSchema.nullable(),
	has_subscription: z.boolean(),
	hash_sum: z.string(),
});
